import { render, staticRenderFns } from "./HandleNumberMigration.vue?vue&type=template&id=6afed16b&scoped=true&"
import script from "./HandleNumberMigration.vue?vue&type=script&lang=js&"
export * from "./HandleNumberMigration.vue?vue&type=script&lang=js&"
import style0 from "./HandleNumberMigration.vue?vue&type=style&index=0&id=6afed16b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afed16b",
  null
  
)

export default component.exports